import { AppDate } from '../envTypes';

import { StoreType } from './profile';
import type { Address } from './address';
import type { SocialAccount } from './store';
import type { LiveStreamExperienceRate } from './livestream';

export enum SellerApplicationStatus {
  approved = 'approved',
  pending = 'pending',
  rejected = 'rejected',
}

export enum AppSellerApplicationType {
  Host = 'HOST',
  Seller = 'SELLER',
}

export interface AppSellerApplicationPurpose {
  slug: string;
  name: string;
}

export interface AppSellerApplication {
  birthday?: AppDate;
  fullName?: string;
  location?: string;
  whereOnline?: string;
  whatSell?: string;
  whatExperienceProducts?: string;
  whatLiveStream?: string;
  whenSell?: string;
  howHearUs?: string;
  sellerAddress?: Address;
  storeName?: string;
  storeDesc?: string;
  website?: string;
  social?: string;
  sellerDesc?: string;
  sellerHasPhysicalStore?: string;
  categoryIds?: string[];
  /**
   * new fields from join.popshop.live
   */

  /* common fields */
  // @deprecated, in favor of storeType
  applicationType?: AppSellerApplicationType;
  storeType?: StoreType;
  // an url short code for the store
  sellerCode?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  country?: string;
  socialAccounts?: SocialAccount;
  additionalNotes?: string;
  category?: string;

  billingCountryCode?: string;

  /* for seller or business application */
  // something like '10l - 50k' or '500k+'
  businessName?: string;
  totalCommunityReach?: string;
  productTypes?: string[];
  annualSalesRevenue?: string;
  monthlySalesRevenue?: string;
  liveStreamExperience?: string;
  liveStreamExperienceRate?: LiveStreamExperienceRate;
  // Who will be hosting your shows
  hostingOperator?: string;

  /* for host or creator application */
  experienceInRetailSales?: string[];
  interestedInPromoting?: boolean;
  openQuestion?: string;

  // since 2023.12.13
  allowSMS?: boolean;
  /**
   * 1. my own products
   * 2. products dropship catalog
   * 3. both
   */
  productSource?: string;
}
